module.exports = __webpack_public_path__ + "static/media/items.c1b8393d.svg";